// extracted by mini-css-extract-plugin
export default {"emphasis":"styles_emphasis__0XX9D"};